<template>
  <van-overlay show z-index="1000">
    <div class="overlay-wrapper px-10" @click.stop>
      <div class="block rounded-medium">
        <div>
          <div class="mb-2">
            <span>您需要在微信中打开才能参与</span>
          </div>
          <div class="flex items-center justify-center">
            <img class="mr-1" src="/mobile/img/weixin-icon.png" alt="" width="16" />
            <span class="text-medium text-theme-black-650 align-bottom"> 用微信扫一扫下面的二维码 </span>
          </div>
        </div>
        <div class="text-center mt-2">
          <qr :url="url" />
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import Qr from './c/Qr'
import { OAUTH_INFO_API_URL } from 'dygc'

export default {
  name: 'OverlayOnlyWeixin',
  components: { Qr },
  data() {
    const origin = window.origin
    return {
      url: `${origin}${OAUTH_INFO_API_URL}?returnUrl=${encodeURIComponent(`${origin}/mobile${location.search}`)}`
    }
  }
}
</script>
